import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const InformationContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
  padding: ${theme.spacing.lg};
  box-shadow: ${theme.dropShadow[200]};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.primary};
  max-width: 20rem;
`;
